export default function generatePublicPrivateClassNames(classNames: string[], styles: any) {
    return classNames.reduce((classNameString, className) => {
        return `${classNameString} ${className} ${styles[className] ?? ""}`;
    }, "").replace(/  +/g, " ");
};